var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHamb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 1,
    clipPath: "url(#clip0_401_306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.244873 2.93878C0.244873 1.45099 1.45096 0.244898 2.93875 0.244898H6.36732V1.71429H2.93875C2.26248 1.71429 1.71426 2.26251 1.71426 2.93878V6.36735H0.244873V2.93878Z",
    fill: "#2B2F2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7599 2.93878C24.7599 1.45099 23.5538 0.244898 22.066 0.244898H18.6375V1.71429H22.066C22.7423 1.71429 23.2905 2.26251 23.2905 2.93878V6.36735H24.7599V2.93878Z",
    fill: "#2B2F2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7599 21.0612C24.7599 22.549 23.5538 23.7551 22.066 23.7551H18.6375V22.2857H22.066C22.7423 22.2857 23.2905 21.7375 23.2905 21.0612V17.6327H24.7599V21.0612Z",
    fill: "#2B2F2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.244873 21.0612C0.244873 22.549 1.45096 23.7551 2.93875 23.7551H6.36732V22.2857H2.93875C2.26248 22.2857 1.71426 21.7375 1.71426 21.0612V17.6327H0.244873V21.0612Z",
    fill: "#2B2F2C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4 8H21V10H4V8ZM4 14H21V16H4V14Z",
    fill: "#2B2F2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamb);
export default __webpack_public_path__ + "static/media/hamb.e5593ac89ed05749ba51031cbbdd048d.svg";
export { ForwardRef as ReactComponent };